import { Component, OnInit, ViewChild } from '@angular/core';
import { Usuario } from '../shared/model/usuario';
import { UsuarioService } from '../shared/service/usuario/usuario.service';
import { environment } from '../../environments/environment';
import { Location } from '@angular/common';
import { UtilService } from '../shared/service/util/util.service';

export interface FormModel {
  captcha?: string;
}

@Component({
  selector: 'app-email-ativacao',
  templateUrl: './email-ativacao.component.html',
  styleUrls: ['./email-ativacao.component.css'],
  styles: [`
      .error { color: crimson; }
  ` ],
})
export class EmailAtivacaoComponent implements OnInit {

  public formModel: FormModel = {};
  public usuario = new Usuario();
  public error: boolean = false;
  public recaptchaSiteKey: string;
  public verificaCadastrado: boolean;

  @ViewChild('captchaProtectedForm', { static: true }) form;

  constructor(private usuarioService: UsuarioService,
    private location: Location,
    private utilService: UtilService) {
  }

  ngOnInit() {
    this.recaptchaSiteKey = environment.recaptchaSiteKey;
  }

  reenviarEmail() {
    this.usuario.urlAcesso = this.utilService.getSubdominio();
    
    this.usuarioService.reenviarEmail(this.usuario).subscribe(
      () => {
        this.utilService.showSuccess("E-mail reenviado com sucesso. Verifique seu e-mail e siga as instruções para ativá-lo.");
        this.error = false;
      },
      err => {
        this.error = true;
        this.utilService.showError(err.message);
      }
    );
  }

  lowerCase(email: string) {
    if (email !== undefined)
      this.usuario.email = email.toLowerCase();
  }

  cancelar() {
    this.location.back();
  }
}